function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import InsertionCard from "@vueEntry/InsertionCard.vue";
import { defineComponent } from "vue";
import { getSimilarRealEstateByREString } from "@services/realEstateAPI";
export default defineComponent({
  name: "SimilarREScrolling",
  components: {
    InsertionCard: InsertionCard
  },
  props: {
    realEstate: {
      type: Object,
      required: true
    },
    similarListingUrl: {
      type: String,
      required: true
    },
    isFavourites: {
      type: Boolean,
      "default": false
    },
    vertical: {
      type: Boolean,
      "default": false
    }
  },
  emits: ["is-similar-re-empty"],
  data: function data() {
    return {
      realEstateList: [],
      loading: true
    };
  },
  computed: {
    loadingLabel: function loadingLabel() {
      //@ts-ignore
      return window["_loadingLabel"];
    },
    viewAllLabel: function viewAllLabel() {
      //@ts-ignore
      return window["_viewAllLabel"];
    }
  },
  mounted: function mounted() {
    var _this = this;
    var observer = new IntersectionObserver(function (entries, observer) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          if (_this.realEstateList.length < _this.getLimit()) {
            getSimilarRealEstateByREString(_this.realEstate, _this.realEstateList.length).then(function (response) {
              if (!response.length) {
                _this.$emit("is-similar-re-empty", true);
                _this.loading = false;
              } else {
                var _this$realEstateList;
                _this.$emit("is-similar-re-empty", false);
                (_this$realEstateList = _this.realEstateList).push.apply(_this$realEstateList, _toConsumableArray(response));
                observer.observe(entry.target);
              }
            });
          } else {
            _this.loading = false;
          }
        }
      });
    }, {
      threshold: 1
    });
    var loadingElement = document.getElementById("infinite-scrolling-loading");
    observer.observe(loadingElement);
  },
  methods: {
    getLimit: function getLimit() {
      return window["infiniteScrolling"] || 4;
    }
  }
});